document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-wa-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.waOpen);
    if (dialog && !dialog.open) {
      const parentDialog = opener.closest('dialog');
      if (parentDialog && parentDialog !== dialog) parentDialog.close();
      dialog.waOpener = parentDialog?.waOpener || opener;
      dialog.showModal();
    }
  }
  const closer = event.target.closest('[data-wa-close]');
  if (closer) closer.closest('dialog').close();
  const dialog = event.target;
  if (dialog instanceof HTMLDialogElement && dialog.open) {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }
  const tab = event.target.closest('[data-wa-category]');
  if (tab) {
    const section = tab.closest('[data-wa-categories]');
    section.querySelectorAll('[data-wa-category]').forEach(button => button.setAttribute('aria-pressed', String(button === tab)));
    section.querySelectorAll('[data-wa-group]').forEach(card => {
      card.hidden = !['all', tab.dataset.waCategory].includes(card.dataset.waGroup);
    });
  }
  const scrollButton = event.target.closest('[data-wa-scroll]');
  if (scrollButton) {
    const rail = scrollButton.closest('[data-wa-rail-section]').querySelector('[data-wa-rail]');
    rail?.scrollBy({left: rail.clientWidth * Number(scrollButton.dataset.waScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
});
const waSavedKey = 'willpower-saved-products';
let waSaved = new Set();
try {
  const saved = JSON.parse(localStorage.getItem(waSavedKey) || '[]');
  if (Array.isArray(saved)) waSaved = new Set(saved.filter(value => typeof value === 'string' && /^[a-z0-9-]+$/.test(value)).slice(0, 100));
} catch {}
const waSyncSavedButtons = () => document.querySelectorAll('[data-wa-save]').forEach(button => button.setAttribute('aria-pressed', String(waSaved.has(button.dataset.waSave))));
const waWriteSaved = () => {
  try { localStorage.setItem(waSavedKey, JSON.stringify([...waSaved])); } catch {}
  waSyncSavedButtons();
};
const waRenderSaved = async () => {
  const dialog = document.querySelector('[data-wa-wishlist]');
  if (!dialog) return;
  const list = dialog.querySelector('[data-wa-saved-list]');
  const status = dialog.querySelector('[data-wa-saved-status]');
  status.dataset.emptyText ||= status.textContent;
  status.textContent = status.dataset.emptyText;
  list.replaceChildren();
  status.hidden = waSaved.size > 0;
  if (!waSaved.size) return;
  const handles = [...waSaved];
  const results = await Promise.allSettled(handles.map(async handle => {
    const base = dialog.dataset.root.replace(/\/$/, '');
    const response = await fetch(`${base}/products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) throw new Error('Unavailable product');
    return response.json();
  }));
  for (let index = 0; index < results.length; index++) {
    const result = results[index];
    const handle = handles[index];
    if (!waSaved.has(handle)) continue;
    if (result.status === 'rejected') {
      status.hidden = false;
      status.textContent = dialog.dataset.error;
      continue;
    }
    const product = result.value;
    const row = document.createElement('article');
    row.className = 'wa-saved-row';
    const link = document.createElement('a');
    link.href = `${dialog.dataset.root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}`;
    if (product.featured_image) {
      const image = document.createElement('img');
      const source = new URL(product.featured_image, location.origin);
      if (['https:', 'http:'].includes(source.protocol)) {
        source.searchParams.set('width', '180');
        image.src = source.href;
        image.alt = '';
        image.width = 80;
        image.height = 100;
        image.loading = 'lazy';
        link.append(image);
      }
    }
    const title = document.createElement('span');
    title.textContent = product.title;
    link.append(title);
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'wa-icon';
    remove.textContent = '×';
    remove.setAttribute('aria-label', dialog.dataset.removeLabel);
    remove.addEventListener('click', () => {
      waSaved.delete(handle);
      waWriteSaved();
      waRenderSaved();
    });
    row.append(link, remove);
    list.append(row);
  }
};
document.addEventListener('click', event => {
  const save = event.target.closest('[data-wa-save]');
  if (save) {
    const handle = save.dataset.waSave;
    if (waSaved.has(handle)) waSaved.delete(handle);
    else if (waSaved.size < 100) waSaved.add(handle);
    waWriteSaved();
  }
  const opener = event.target.closest('[data-wa-open]');
  if (opener && document.getElementById(opener.dataset.waOpen)?.matches('[data-wa-wishlist]')) waRenderSaved();
});
document.addEventListener('shopify:section:load', waSyncSavedButtons);
waSyncSavedButtons();
new MutationObserver(waSyncSavedButtons).observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
document.addEventListener('close', (event) => {
  if (event.target instanceof HTMLDialogElement) event.target.waOpener?.focus();
}, true);
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
});
